import { render, staticRenderFns } from "./CreatePostModal.vue?vue&type=template&id=6cde944a&scoped=true&"
import script from "./CreatePostModal.vue?vue&type=script&lang=js&"
export * from "./CreatePostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cde944a",
  null
  
)

export default component.exports